import { type Swatch } from '../../../../../api'

export const swatch1: Swatch = {
  __typename: 'Swatch',
  id: 'U3dhdGNoOmUyNmQyMGY3LWNlNmEtNDcwMS04N2U2LWU2ZTM2NzlmMDY4Zg==',
  hue: 360,
  saturation: 97.873924,
  lightness: 52.965,
}
